import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocalStorage } from 'hooks/useLocalStorage';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';

const SPOTLIGHT_TIME_KEY = 'cn_spotlight_time_configuration'
const SESION_SPOTLIGHT_SHOWN_KEY = 'hasSpotlightShownInSession';

// https://dlatvarg.atlassian.net/browse/WEBCL-1522
// El tiempo de visualización "default" del Spotlight por 5 segundos
const DEFAULT_SPOTLIGHT_TIME_IN_SECONDS = 5;

export const UseSpotlight = () => {
  const [isSpotlightVisible, setSpotlightVisible] = useState(false);
  const [hasSeenSpotlight, setHasSeenSpotlight] = useLocalStorage(SESION_SPOTLIGHT_SHOWN_KEY, false);
  const timerRef = useRef(null);

  const userId = useSelector(state => state.user.user_id);
  const showProfileLoader = useSelector(state => state?.profilesManager?.showLoader);
  const spotlightKey  =  useSelector(selectMetadataKeyByRegion(SPOTLIGHT_TIME_KEY));
  const { showNotification } = useSelector(state => state?.cvNotifications);
  const { triggered, shown } = useSelector(state => state?.videoBanner);
  const isBannerActive = triggered && !shown;

  const spotlightTimeInSeconds = spotlightKey?.time_in_seconds || DEFAULT_SPOTLIGHT_TIME_IN_SECONDS;

  const spotlightTimeInMillis = spotlightTimeInSeconds * 1000;

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  useLayoutEffect(() => {
    if (
      !userId // usuario no logeado
      || hasSeenSpotlight // spotlight ya ha sido mostrado
      || showProfileLoader // si el contenido aun no es visible
      || !showNotification // notificacion replegada
      || timerRef.current // timer ya en curso
      || isBannerActive
    ) return;

    setSpotlightVisible(true);
    setHasSeenSpotlight(true);

    timerRef.current = setTimeout(() => {
      setSpotlightVisible(false);
      timerRef.current = null;
    }, spotlightTimeInMillis);
  }, [showProfileLoader, showNotification, isBannerActive]);

  return [isSpotlightVisible, setSpotlightVisible, setHasSeenSpotlight, triggered, shown];
}
